export const DASHBOARD = {
  statRecords: 'dashboard-stat-records',
  statInspections: 'dashboard-stat-inspections',
  statInspectionsPendientes: 'dashboard-stat-inspections-pendientes',
  statRecorridos: 'dashboard-stat-recorridos',
  statNovedades: 'dashboard-stat-novedades',
  statSellosRotos: 'dashboard-stat-sellos-rotos',
  statSellosColocados: 'dashboard-stat-sellos-colocados',
  statVisitas: 'dashboard-stat-visitas',
  statEmbarques: 'dashboard-stat-embarques',
  statRecibos: 'dashboard-stat-recibos',
  novedadesList: 'dashboard-novedades-list',
};
